export const STEP_FORM_FIELDS =
{
    employeeCount:{
      value: null,
      tempValue: null,
      required: true,
      error: false,
      step: 1
    },
    geography:{
      value: [],
      tempValue: null,
      required: true,
      error: false,
      step: 1
    },
    industry:{
      value: null,
      tempValue: null,
      required: false,
      error: false,
      step: 1
    },
    salesRange:{
      value: null,
      tempValue: null,
      required: false,
      error: false,
      step: 1
    },
    propertiesRange:{
      value: null,
      tempValue: null,
      required: false,
      error: false,
      step: 1
    },
    problems:{
      value: [],
      tempValue: null,
      required: false,
      error: false,
      step: 1
    },
    directMarketing:{
      value: null,
      tempValue: null,
      required: true,
      error: false,
      step: 2
    },
    dataReports:{
      value: null,
      tempValue: null,
      required: true,
      error: false,
      step: 2
    },
    notify:{
      value: null,
      tempValue: null,
      required: true,
      error: false,
      step: 3
    },
    dataExports:{
      value: null,
      tempValue: null,
      required: true,
      error: false,
      step: 3
    },
    digitalProposals:{
      value: null,
      tempValue: null,
      required: true,
      error: false,
      step: 3
    },
}
